var _a;
export var ResizeAPI;
(function (ResizeAPI) {
    ResizeAPI["Rembrandt"] = "rembrandt";
    ResizeAPI["Vanbrandt"] = "vanbrandt";
    ResizeAPI["Vangogh"] = "vangogh";
})(ResizeAPI || (ResizeAPI = {}));
export var ResizeMode;
(function (ResizeMode) {
    ResizeMode["Fill"] = "fill";
    ResizeMode["Fit"] = "fit";
})(ResizeMode || (ResizeMode = {}));
export var VangoghResizeMode;
(function (VangoghResizeMode) {
    VangoghResizeMode["Srz"] = "srz";
    VangoghResizeMode["Srb"] = "srb";
})(VangoghResizeMode || (VangoghResizeMode = {}));
export var VangoghMode = (_a = {},
    _a[ResizeMode.Fill] = VangoghResizeMode.Srz,
    _a[ResizeMode.Fit] = VangoghResizeMode.Srb,
    _a);
export var MediaManagerVersion;
(function (MediaManagerVersion) {
    MediaManagerVersion["G5"] = "G5";
    MediaManagerVersion["G6"] = "G6";
})(MediaManagerVersion || (MediaManagerVersion = {}));
export var MediaType;
(function (MediaType) {
    MediaType["Picture"] = "picture";
    MediaType["SiteIcon"] = "site_icon";
    MediaType["Watermark"] = "watermark";
    MediaType["SecurePicture"] = "secure_picture";
    MediaType["Video"] = "video";
    MediaType["VideoAlpha"] = "videoalpha";
    MediaType["SecureVideo"] = "secure_video";
    MediaType["UserFont"] = "ufont";
    MediaType["Shape"] = "shape";
})(MediaType || (MediaType = {}));
//# sourceMappingURL=types.js.map